import { createUseStyles } from 'react-jss';

import styling from '../../../services/styling';

export default createUseStyles(
  {
    wrapper: {
      position: 'relative',
    },
    backgroundCircle: {
      position: 'absolute',
      left: '50%',
      top: '50%',
      transform: 'translate(-50%, -50%)',
      height: 0,
      width: '100%',
      maxWidth: 645,
      '&:before': {
        content: '""',
        position: 'absolute',
        left: '50%',
        top: '50%',
        width: '100%',
        paddingBottom: '100%',
        opacity: 0.13,
        filter: 'blur(40px)',
        transform: 'translate(-50%, -50%)',
        borderRadius: '100%',
        background: `radial-gradient(circle, ${styling.colors.theme.secondary} 0%, ${styling.colors.theme.transparent} 100%)`,
      },
    },
    header: {
      textAlign: 'center',
      [styling.breakpoints.up('md')]: {
        padding: [0, 80],
      },
      '& > h2': {
        display: 'inline-block',
      },
    },
    calculated: {
      marginTop: 40,
    },
    buttonWrapper: {
      maxWidth: 782,
      margin: [20, 'auto', 80],
      textAlign: 'center',
      [styling.breakpoints.up('md')]: {
        margin: [56, 'auto', 120],
      },
    },
    button: {
      display: 'inline-block',
      paddingRight: 48,
      paddingLeft: 48,
    },
  },
  { name: 'homeStats' },
);
